import HttpResponse from "../../../../../../utils/http/http.response";

export enum BillingsOrderForwardRelatedCargoTaxiResponseDataContractBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export enum BillingsOrderForwardRelatedCargoTaxiResponseDataBillingStatus {
  CREATED = "CREATED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  REOPEN_REQUEST = "REOPEN_REQUEST",
  REOPENED = "REOPENED",
}

export type BillingsOrderForwardRelatedCargoTaxiResponseDataContractCargoCompany =
  {
    displayName: string;
  };

export type BillingsOrderForwardRelatedCargoTaxiResponseDataContract = {
  model: BillingsOrderForwardRelatedCargoTaxiResponseDataContractBillingModel;
  distanceRate: number;
  cargoCompany: BillingsOrderForwardRelatedCargoTaxiResponseDataContractCargoCompany;
};

export type BillingsOrderForwardRelatedCargoTaxiResponseDataCargoOrder = {
  id: string;
  humanId: number;
};

export type BillingsOrderForwardRelatedCargoTaxiResponseData = {
  id: string;
  draft: boolean;
  distance: number;
  amountForChargeHighways: number | null;
  amountForChargeHaltings: number | null;
  allContributionsAmount: number | null;
  amountForDistance: number | null;
  date: Date;
  cargoOrder: BillingsOrderForwardRelatedCargoTaxiResponseDataCargoOrder;
  contract: BillingsOrderForwardRelatedCargoTaxiResponseDataContract;
  contractCorrectionPercentage: number | null;
  sumOfDiscounts: number | null;
  status: BillingsOrderForwardRelatedCargoTaxiResponseDataBillingStatus;
};

type BillingsOrderForwardRelatedCargoTaxiResponse = HttpResponse<
  BillingsOrderForwardRelatedCargoTaxiResponseData[]
>;

export default BillingsOrderForwardRelatedCargoTaxiResponse;
